import BaseModelAPI from '../BaseModelAPI';

export default class MaritalStatusList extends BaseModelAPI {

	static entity = 'maritalstatuslist'
	static entityName = 'maritalstatus';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
